/* eslint-disable no-tabs */
import { dehydrate, QueryClient } from '@tanstack/react-query';
import { GetServerSideProps } from 'next';
import dynamic from 'next/dynamic';

import { PUBLISHING_KD } from 'src/constants/services';
import Events from 'src/containers/Events';
import { listEventQueryKey } from 'src/hooks/Events/useListEvent';
import { tcListQueryKey } from 'src/hooks/Events/useTCList';
import wrapper from 'src/redux';
import { actionGetFooterMenu, actionGetMenu } from 'src/redux/actions';
import { fetchApiV3Publishing } from 'src/utils/fetch-api';
import { getLayoutMobileServer } from 'src/utils/layout-mobile';

const HeadC = dynamic(() => import('src/components/Head'));
const ListEventPage = () => {
	return (
		<>
			<HeadC title="Daftar Event - KlikDokter" description={''} hideSuffix />
			<Events />
		</>
	);
};

export const getServerSideProps: GetServerSideProps = wrapper.getServerSideProps(
	(store) => async (ctx) => {
		const queryClient = new QueryClient();

		const category = ctx.query.category as string | undefined;

		const upcomingPayload = {
			page: 1,
			per_page: 2,
			event_status: 'upcoming',
			...(category ? { tc_code: category } : {}),
		};

		const ongoingPayload = {
			page: 1,
			per_page: 2,
			event_status: 'ongoing',
			...(category ? { tc_code: category } : {}),
		};

		await store.dispatch(actionGetMenu());
		await store.dispatch(actionGetFooterMenu());
		await queryClient.prefetchInfiniteQuery({
			queryKey: [listEventQueryKey, 'upcoming', upcomingPayload],
			queryFn: ({ pageParam = 1 }: { pageParam?: any }) =>
				fetchApiV3Publishing({
					url: `/${PUBLISHING_KD.service}/${PUBLISHING_KD.model.events}`,
					options: { method: 'GET' },
					payload: {
						...upcomingPayload,
						page: pageParam,
					},
				}),
			initialPageParam: 1,
		});

		await queryClient.prefetchInfiniteQuery({
			queryKey: [listEventQueryKey, 'ongoing', ongoingPayload],
			queryFn: ({ pageParam = 1 }: { pageParam?: any }) =>
				fetchApiV3Publishing({
					url: `/${PUBLISHING_KD.service}/${PUBLISHING_KD.model.events}`,
					options: { method: 'GET' },
					payload: {
						...ongoingPayload,
						page: pageParam,
					},
				}),
			initialPageParam: 1,
		});

		await queryClient.prefetchQuery({
			queryKey: tcListQueryKey,
			queryFn: () =>
				fetchApiV3Publishing({
					url: `/${PUBLISHING_KD.service}/${PUBLISHING_KD.model.eventTc}/list`,
					options: { method: 'GET' },
				}),
		});

		return {
			props: {
				dehydratedState: JSON.parse(JSON.stringify(dehydrate(queryClient))),
				pageHeaderContent: {
					title: 'Event by Klik Dokter',
					hideHeadingTitle: true,
					breadcrumbs: [{ label: 'Daftar Event', navigatePath: '/list-event' }],
					description: 'Temukan berbagai event kesehatan yang bisa kamu ikuti!',
				},
				layoutMobile: getLayoutMobileServer(ctx),
				events: {
					category: category || null,
				},
			},
		};
	},
);

export default ListEventPage;
